module.exports = __webpack_public_path__ + "img/markPoint7.e4f63406.png";